// Tables the geocoder can run on. Mirrors GEOCODER_TABLES in server/modules/mysql/mysql.py
export const GEOCODER_TABLES = [
  "ReviewPlatforms",
  "Forums",
  "Twitter",
  "Instagram",
  "Linkedin",
  "TikTok",
  "Facebook",
  "China"
];
